'use strict';

module.exports = Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_filter_by_price'),
    viewClass: require('../modules/views/accommodation_filter_by_price'),
    refreshSlider: function() {
        this.view.slider.updateHandlers();
    },
    refreshHistogram: function() {
        this.view.refreshHistogram();
    },
});
